import type { ReactNode } from "react";
import { Switch } from "antd";
import type { SwitchProps } from "antd";
import { twMerge } from "tailwind-merge";
import { IconQuestion } from "@icons/index";
import { DarkTooltip } from "@components/DarkTooltip";

export interface ClipSwitchProps extends Omit<SwitchProps, "title"> {
  title: ReactNode;
  description?: ReactNode;
  className?: string;
}

export const ClipSwitch = (props: ClipSwitchProps) => {
  const { title, description, className, size = "small", ...switchProps } = props;

  return (
    <div className={twMerge("flex items-center justify-start gap-[8px] rounded-[4px] py-[4px] pr-[8px]", className)}>
      <div className="flex min-w-0 items-center gap-[4px]">
        <span className="truncate text-[16px] font-bold leading-[22px] text-kds-fg">{title}</span>
        {description ? (
          <DarkTooltip
            title={description}
            placement="topLeft"
            styles={{
              container: {
                minWidth: 430,
                whiteSpace: "nowrap",
              },
            }}
          >
            <IconQuestion className="size-[13px]" />
          </DarkTooltip>
        ) : null}
      </div>
      <Switch size={size} {...switchProps} />
    </div>
  );
};
